import { AlertTriangle, RefreshCw } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export const DashboardSkeleton = ({ testId = "page-loading", cards = 4 }) => (
  <div className="space-y-8" data-testid={testId} aria-busy="true">
    <div className="space-y-3">
      <Skeleton className="h-6 w-28 rounded-full" />
      <Skeleton className="h-11 w-72 max-w-full" />
      <Skeleton className="h-5 w-96 max-w-full" />
    </div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {Array.from({ length: cards }).map((_, index) => <Skeleton key={index} className="h-28 rounded-2xl" />)}
    </div>
    <Skeleton className="h-64 rounded-3xl" />
  </div>
);

export const LoadError = ({ message = "This page could not load.", onRetry, testId = "page-load-error" }) => (
  <div data-testid={testId} role="alert" className="p-6 rounded-2xl bg-red-50 border border-red-200 text-red-900">
    <div className="flex items-start gap-3"><AlertTriangle size={20} className="mt-0.5 shrink-0" /><div><div className="font-semibold">Unable to load</div><div className="text-sm mt-1">{message}</div></div></div>
    {onRetry && <button type="button" data-testid={`${testId}-retry`} onClick={onRetry} className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-700 hover:bg-red-800 text-white text-sm font-semibold"><RefreshCw size={14} /> Retry</button>}
  </div>
);